import React, {useEffect, useState} from 'react';

import {useSelector, useDispatch} from 'react-redux';

// import { FontSizeChanger } from 'react-font-size-changer';
// import { connect } from 'react-redux';
import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {getSambaUser as getSambaUserApi, postSambaUser, putSambaUser} from '@/api/sambaUserApi';
import InputField from '@/components/inputfield/InputField';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import {isContainSymbol} from '@/libs/nameHelper';
import {gapFixerClass} from '@/libs/styleHelper';

import '../../../styles/variable.less';
import BottomMenu from '../../menu/bottommenu/BottomMenu';

import './GeneralSetting.scss';

/**
 * @fixme behavior enabled/disabled when change password is not clear
 */
export function GeneralSetting() {
  const dispatch = useDispatch();
  const fontSize = useSelector((state) => state.setupStore.fontSize);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [savedUsername, setSavedUsername] = useState('');
  const [savedPassword] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const style = {
    constraint: {
      fontSize,
      display: 'flex',
    },
  };

  useEffect(() => {
    dispatch(setupActions.updateActiveMenu(APPDATA.GENERAL_SETTING));
    setTopMenuProperties();
    getSambaUser();
  }, []);

  useEffect(() => {
    setTopMenuProperties();
  }, [username, password, savedUsername]);

  const getSambaUser = () => {
    getSambaUserApi()
      .then((response) => {
        const {data} = response;
        setUsername(data.UserName);
        setSavedUsername(data.UserName);
        setIsNewUser(false);
      })
      .catch((err) => {
        console.log('getSambaUser message', err);
        setIsNewUser(true);
      });
  };

  const setupTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  const goToHomeScreen = () => {
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  const saveSettings = () => {
    if (isNewUser) {
      postSambaUser(username, password)
        .then(() => {
          goToHomeScreen();
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.EXIT_SAVE_PAGE.SAVE_SUCCESS,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
            }),
          );
        })
        .catch((err) => {
          console.log('Error messages ', err.response.data);
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: err.response.data,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        });
    } else {
      putSambaUser(username, password)
        .then(() => {
          goToHomeScreen();
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.EXIT_SAVE_PAGE.SAVE_SUCCESS,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
            }),
          );
        })
        .catch((err) => {
          console.log('Error messages ', err.response.data);
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: err.response.data,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        });
    }
  };

  const onClickPopUpButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.DISCARD:
        goToHomeScreen();
        break;
      case APPDATA.SAVE:
        saveSettings();
        break;
      default:
        break;
    }
    dispatch(modalActions.hidePopUp());
  };

  const displayPopUp = () => {
    const popUpButton = [
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: onClickPopUpButton,
        label: APPDATA.CANCEL.toUpperCase(),
        className: 'tertiaryButton',
      },
      {
        id: APPDATA.DISCARD,
        isPrimaryButton: false,
        onClick: onClickPopUpButton,
        label: APPDATA.DISCARD,
      },
      {
        id: APPDATA.SAVE,
        isPrimaryButton: true,
        onClick: onClickPopUpButton,
        label: APPDATA.SAVE,
      },
    ];
    dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.EXIT_SAVE_PAGE.TITLE,
        popUpText: (
          <div>
            {APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.EXIT_SAVE_PAGE.TEXT}
            <br />
            {APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.EXIT_SAVE_PAGE.QUESTION}
          </div>
        ),
        popUpQuestion: undefined,
        popUpButton,
        popUpHideCloseButton: true,
      }),
    );
  };

  const backAction = () => {
    const noPopup = isNewUser
      ? username === '' || password === ''
      : (username === savedUsername && password === '') || username === '';

    if (noPopup) {
      goToHomeScreen();
    } else {
      displayPopUp();
    }
  };

  const saveAction = () => displayPopUp();

  const setTopMenuProperties = () => {
    const disableMainButton = !username || !password || (username === savedUsername && savedPassword === password);
    // isNewUser ? !username || !password : username === savedUsername || !password || !username;

    const TopButtonProperties = {
      id: APPDATA.SAVE,
      label: APPDATA.SAVE,
      onClick: saveAction,
      disabled: disableMainButton,
    };
    const BackButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: backAction,
    };
    const titleMenuProperties = APPDATA.SYSTEM_SETTING;
    setupTopMenuProperties(TopButtonProperties, BackButtonProperties, titleMenuProperties);
  };

  const onChange = async (e) => {
    switch (e.type) {
      case APPDATA.DATA_COLLECTION_USERNAME: {
        if (isContainSymbol(e.value)) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.USERNAME_LENGTH_AND_SYMBOL,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else if (e.value === undefined) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: isNewUser
                ? APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.USERNAME_PASSWORD_CANNOT_BE_EMPTY
                : APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.USERNAME_CANNOT_BE_EMPTY,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else if (e.value.toLowerCase() === 'admin') {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.USERNAME_CANNOT_ADMIN,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else if (e.value.length < 8 || e.value.length > 20) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.USERNAME_LENGTH_AND_SYMBOL,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else {
          setUsername(e.value);
        }
        break;
      }
      case APPDATA.DATA_COLLECTION_PASSWORD: {
        // can't contain symbols. At least 8 char
        if (isContainSymbol(e.value)) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.PASSWORD_LENGTH_AND_SYMBOL,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else if (!isNewUser && e.value === undefined) {
          setPassword('');
        } else if (e.value === undefined && isNewUser) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.USERNAME_PASSWORD_CANNOT_BE_EMPTY,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else if (e.value.length < 8) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.PASSWORD_LENGTH_AND_SYMBOL,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else if (e.value.toLowerCase() === username.toLowerCase()) {
          dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.SYSTEM_SETTING.GENERAL_SETTING.FIELD_ERROR.PASSWORD_CANNOT_SAME_AS_USERNAME,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        } else {
          setPassword(e.value);
        }
        break;
      }
      default:
        break;
    }
  };

  const onClick = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.DATA_COLLECTION_USERNAME:
        dispatch(
          modalActions.showKeyboard({
            keyboardValue: username,
            keyboardTitle: APPDATA.DATA_COLLECTION_USERNAME,
            keyboardPlaceholder: APPDATA.DATA_COLLECTION_USERNAME_PLACEHOLDER,
            keyboardCallBack: onChange,
            max: 20,
            disableSymbols: true,
          }),
        );
        break;
      case APPDATA.DATA_COLLECTION_PASSWORD:
        dispatch(
          modalActions.showKeyboard({
            keyboardValue: password,
            keyboardTitle: APPDATA.DATA_COLLECTION_PASSWORD,
            keyboardPlaceholder: APPDATA.DATA_COLLECTION_PASSWORD_PLACEHOLDER,
            keyboardCallBack: onChange,
            max: 20,
            disableSymbols: true,
          }),
        );
        break;
      default:
    }
  };

  const onClickResetDefault = () => {
    setUsername(savedUsername);
    setPassword(savedPassword);
  };

  return (
    <div
      style={style.constraint}
      className={`flex-col ${gapFixerClass()}`}
    >
      <div className="flex-between rowHeight">
        <div>
          <span className="subheading">Data Collection Authentication on Remote Device</span>
        </div>
        <div>
          <button
            type="button"
            className="ResetButton"
            onClick={onClickResetDefault}
            disabled={username === savedUsername && password === savedPassword}
          >
            {APPDATA.RESET.toUpperCase()}
          </button>
        </div>
      </div>
      <div className="row rowHeight middleAlign">
        <div className={APPSTYLE.COLUMN_FULL}>
          <InputField
            label={APPDATA.DATA_COLLECTION_USERNAME}
            inputValue={username}
            fullWidthInput
            onClick={onClick}
          />
          <span className="information-messages">
            *Username must be between 8 to 20 characters and cannot contain symbols
          </span>
          <br />
          <br />
        </div>
      </div>
      <div className="row rowHeight middleAlign">
        <div className={APPSTYLE.COLUMN_FULL}>
          <InputField
            label={APPDATA.DATA_COLLECTION_PASSWORD}
            inputValue={password}
            fullWidthInput
            onClick={onClick}
            type="password"
          />
          <span className="information-messages">
            *Password must be at least 8 characters and cannot contain symbols
          </span>
          <br />
          <span className="information-messages">
            **Username and Password are used to access history logs on remote device
          </span>
        </div>
      </div>

      <BottomMenu />
    </div>
  );
}

export default GeneralSetting;
